import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import StoreContext from './Context/Store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import { SavingProvider } from './store/SavinContext';
import { S3provider } from './store/s3Context';
import 'react-modern-drawer/dist/index.css';

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.Fragment>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_KEY}  >
      <S3provider>
        <SavingProvider>

          <StoreContext>
            <App />
          </StoreContext>
        </SavingProvider>
      </S3provider>
    </GoogleOAuthProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
